import React from 'react';
import HeaderSection from './HeaderSection';
import AboutSection from './AboutSection';
import Clients from './Clients';
import OurTeams from './OurTeams';
import Services from './Services';
import Footer from '../components/Footer';
import ReactDOM from 'react-dom';
const HomePage = () => (
  <main className="home-page">
    <HeaderSection />
    <AboutSection />
    <OurTeams />
    <Services />
    <Footer />
  </main>
)
export default HomePage;



// WEBPACK FOOTER //
// ./src/HomePage/index.js